import React from 'react';
import PlayersApi from "../../api/Players";
import { toast } from "react-toastify";
import Datepicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './addPlayer.css';

export default class AddPlayers extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            selectedPlayers: [],
            players: [],
            player:[]
        };
    }

    savePlayer(player,closeModal){
        let p = this.state.player
        p.team_id = this.props.team.id;
        if(p != []){
            if(p.hasOwnProperty('birthday')){
                p.birthday = p.birthday.format('DD/MM/YYYY');
            }
            let state = {...this.state};
            PlayersApi.create(p).then(res => {
                console.log(res)
                toast.success("Datos actualizados");
            })
            this.state.player.birthday = ""
            this.state.player.name = ""
            this.state.player.dorsal = ""
            this.setState(state);
        }
    }

    componentWillMount(){
        let state = {...this.state};
        PlayersApi.getAll().then(res => {
            state.players = res.data.response;
            this.setState(state);
        }).catch(err => toast.error('Error al recibir la información, intente nuevamente'));
    }

    onDateChange(d){
        let state = {...this.state};
        state.player.birthday = d
        this.setState(state);
    }

    handleKeyPress(e){
        if (e.key === 'Enter') {
            this.savePlayer(this.state.selected)
        }
    }

    handleFileUpload(files) {
        let state = {...this.state};
        state.player.img = files
        this.setState(state);
      }

    render(){
        return (
            <div>
                <div className="FieldHorizontal field is-horizontal">
                    <div className="field-label">
                        <label className="label">Nombre</label>
                    </div>
                    <div className="field-body">
                        <input className="input" value={this.state.player.name ? this.state.player.name :""} type="text" autoFocus onKeyPress={(e) => this.handleKeyPress(e)} placeholder="Nombre" onChange={(e) => {
                            let state = {...this.state};
                            state.player.name = e.currentTarget.value;
                            this.setState(state);
                        }} />
                    </div>
                </div>
                <div className="FieldHorizontal field is-horizontal">
                    <div className="field-label">
                        <label className="label">Dorsal</label>
                    </div>
                    <div className="field-body">
                        <input className="input" value={this.state.player.dorsal ? this.state.player.dorsal :""} type="text" onKeyPress={(e) => this.handleKeyPress(e)} placeholder="#" onChange={(e) => {
                            let state = {...this.state};
                            state.player.dorsal = e.currentTarget.value;
                            this.setState(state);
                        }} />
                    </div>
                </div>
                <div className="FieldHorizontal field is-horizontal">
                    <div className="field-label">
                        <label className="label">Fecha nac.</label>
                    </div>
                    <div className="field-body">
                        <Datepicker
                            selected={this.state.player.birthday}
                            onChange={(date) => this.onDateChange(date)}
                            showMonthDropdown
                            showYearDropdown
                            className="input"
                            placeholderText="dd/mm/yyyy"
                        />
                    </div>
                </div>
                <div className="FieldHorizontal field is-horizontal">
                    <div className="field-label">
                        <label className="label">Foto</label>
                    </div>
                    <div className="field-body">
                        <input
                            className="input file_input"
                            type="file"
                            onChange={ (e) => this.handleFileUpload(e.target.files) }
                            accept="image/gif, image/jpeg, image/jpg, image/png"
                        />
                    </div>
                </div>
                <div className="columns has-text-right buttons-modal">
                    <div className="column">
                        <button className="button is-primary right20" onClick={() => this.savePlayer(this.state.player)}>Guardar y agregar otro</button>
                        <button className="button is-success" onClick={() => {this.savePlayer(this.state.player);this.props.cancel()}}>Guardar y salir</button>
                        <button className="button" onClick={() => this.props.cancel()}>Cancelar</button>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/team/AddPlayers.js